// extracted by mini-css-extract-plugin
module.exports = {"pill-button":"PillButton_pill-button__Sdmr4"};